import { type UseQueryResult, useQuery } from 'react-query';
import { TransactionService } from '../../services/wealthlane-award-services';

const useGetTransactionStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const transactionStatus = useQuery(
    ['getTransactionStatus'],
    async () => {
      return await handleRequest(
        TransactionService.getApiAwardApiAppTransactionTransactionStatusList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return transactionStatus;
};

export default useGetTransactionStatus;
